<script setup>
    import { ref } from "vue";
    import { useAuthStore } from "@/stores/auth";
    import { useTheme } from "@/utils/composables/useTheme";
    const currentCompany = JSON.parse(localStorage.getItem("currentCompany"));
    const userName = `${currentCompany?.pivot?.first_name.charAt(0).toUpperCase() + currentCompany?.pivot?.first_name.slice(1).toLowerCase()}  ${currentCompany?.pivot?.last_name.charAt(0).toUpperCase() + currentCompany?.pivot?.last_name.slice(1).toLowerCase()}`
    const authStore = useAuthStore();
    import { useRoute } from 'vue-router'
    const route = useRoute()

    import useValidation from '@/utils/helpers/validations';

    const { checkLoggedInUserRole } = useValidation();
    const { isDark, toggleTheme } = useTheme();

    const userMenuOpen = ref(false);
    const logout = () => {
        authStore.logout();
    };



    // onBeforeMount( () => {
    //     fetchUnreadMessagesCounter();
    // });

</script>
<template>
    <div class="header-page">
        <div class="header-page-items flex items-center">
            <router-link to="/">
                <img class="header-logo" src="@/assets/images/logo/hiddenox.svg" alt="Ravo" />
            </router-link>

            <div class="flex items-center gap-3">

                <!-- Theme Toggle — always visible -->
                <button class="header-theme-toggle" @click="toggleTheme" :title="isDark ? 'Switch to light mode' : 'Switch to dark mode'">
                    <i :class="isDark ? 'bi bi-sun-fill' : 'bi bi-moon-fill'"></i>
                </button>

                <div v-if="route.name != 'CompaniesListView' && !checkLoggedInUserRole()" class="line-between"></div>

                <div @click="logout()" v-if="route.name == 'CompaniesListView'">
                    <span class="nav-label logout-action">
                        <i class="bi bi-door-open-fill"></i><span class="ml-5">Logout</span>
                    </span>
                </div>

                <div v-else class="header-dropdown-actions" style="margin-left: 20px; position: relative">
                    <button type="button" class="flex items-center bg-transparent border-0 cursor-pointer" @click="userMenuOpen = !userMenuOpen">
                        <div class="inline-block ml-1 text-left">
                            <p class="user-fullName mb-0">{{ userName }}</p>
                        </div>
                        <svg style="margin-left: 12px" width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.66772 4.64C3.75812 4.74474 3.87001 4.82877 3.99581 4.88637C4.12161 4.94396 4.25836 4.97377 4.39672 4.97377C4.53508 4.97377 4.6718 4.94396 4.7976 4.88637C4.9234 4.82877 5.03532 4.74474 5.12573 4.64L8.57272 0.809998C8.97272 0.362998 8.81571 0 8.21472 0H0.578698C-0.0213019 0 -0.179273 0.365998 0.220727 0.809998L3.66772 4.64Z" fill="#636161"/>
                        </svg>
                    </button>
                    <div v-if="userMenuOpen" class="dropdown-menu-custom" style="right:0; top: calc(100% + 4px)">
                        <button type="button" class="dropdown-item-custom" @click="logout(); userMenuOpen = false">
                            <i class="bi bi-door-open-fill mr-2"></i>Logout
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>